import { FORM_REQUIRED_FIELD_ERROR } from "constants/strings";
import { IAddress } from "models/address/address.model";
import { testZip } from "utils/zip/isZipValid.util";
import * as Yup from "yup";

export const CreateAddressValidationSchema = Yup.object({
  lastName: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
  addressLine1: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
  addressLine2: Yup.string(),
  city: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
  countryIsoCode: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
  company: Yup.string(),
  countyState: Yup.string(),
  phone: Yup.string(),
  email: Yup.string()
    .required(FORM_REQUIRED_FIELD_ERROR)
    .email("Please enter a valid email."),
  zip: Yup.string().when("$isZipRequired", (isZipRequired, field) => {
    const baseValidation = field.test(
      "isValid",
      "Zip code is not valid.",
      testZip
    );
  
    return isZipRequired ? baseValidation.required(FORM_REQUIRED_FIELD_ERROR) : baseValidation;
  })
});

export type ICreateAddressFormValues = Pick<
  IAddress,
  | "firstName"
  | "lastName"
  | "addressLine1"
  | "addressLine2"
  | "city"
  | "company"
  | "phone"
  | "email"
  | "countryIsoCode"
  | "countyState"
  | "zip"
  | "code"
  | "branch"
  | "eoriNumber"
  | "mobile"
  | "residentialAddress"
  | "vatNumber"
>;

export type ICreateAddressDto = ICreateAddressFormValues;
